export const vh = (value: number) => `
  calc(var(--vh) * ${value})
`;
